import { render, staticRenderFns } from "./ReactionBarGraph.vue?vue&type=template&id=558b5e1a&"
import script from "./ReactionBarGraph.vue?vue&type=script&lang=ts&"
export * from "./ReactionBarGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports